'use es6';

import Immutable from 'immutable';
import * as ActionTypes from '../actions/ActionTypes';
const initialMoreAppsState = new Immutable.Map({
  hasCategoryResults: false,
  results: new Immutable.OrderedSet()
});
const initialState = Immutable.fromJS({
  moreApps: initialMoreAppsState,
  referrer: null
});
const details = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case ActionTypes.DETAILS_MORE_APPS_FETCH_RECEIVED:
      return state.set('moreApps', payload);
    case ActionTypes.DETAILS_MORE_APPS_RESET:
      return state.set('moreApps', initialMoreAppsState);
    case ActionTypes.DETAILS_REFERRER_SET:
      {
        return state.set('referrer', payload);
      }
    case ActionTypes.DETAILS_REFERRER_RESET:
      {
        return state.set('referrer', null);
      }
    default:
      return state;
  }
};
export default details;